<template>
  <RestaurantReportsList/>
</template>
<script>
import RestaurantReportsList from '@/components/modules/restaurant/reports/list'
export default {
  name: 'RestaurantReports',
  components: {
    RestaurantReportsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/reports/list.vue